import * as React from 'react';
import './timeline-new-entry.less';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  addTimelineEntryRequest,
  clear,
  setDate,
  setMediaUrl,
  setText,
  setTitle,
} from '../../store/timeline';
import { Box, Button, TextField } from '@mui/material';
 import { DatePicker } from '@mui/x-date-pickers';
import { ChangeEvent } from 'react';
import * as moment from 'moment';

export function TimelineEntry() {
  const isConnected = useSelector(
    (state: RootState) => state.metadata.isWsAlive
  );
  const {title, text, mediaUrl, date } =  useSelector((state: RootState) => state.timeline);
  const dispatch = useDispatch();
  const handleSetTitle = (event) => dispatch(setTitle(event.target.value));
  const handleSetText = (event: ChangeEvent<HTMLTextAreaElement>) => dispatch(setText(event.target.value));
  const handleSetMediaUrl = (event: ChangeEvent<HTMLTextAreaElement>) => dispatch(setMediaUrl(event.target.value));
  const handleSetDate = (value: moment.Moment) => dispatch(setDate(value.format('yyyy-MM-DD')));
  const handleClear = () => dispatch(clear());
  const handleSave = () => dispatch(addTimelineEntryRequest());

  return (
    <>
    <Box display='flex' flexDirection='column' gap={2}>
      <Box display='flex' gap={1}>
        <TextField label='Title' value={title} onChange={handleSetTitle}/>
        <DatePicker label='Date' onChange={handleSetDate} value={!date ? moment() : moment(date)}/>
      </Box>
      <TextField title='Content' value={text} placeholder='🩷 Share something here...' onChange={handleSetText} multiline minRows={8}/>
      <TextField label='📸 URL' value={mediaUrl} onChange={handleSetMediaUrl}/>
      <Box display='flex' justifyContent='center' alignItems='center' gap={1}>
        <Button onClick={handleSave} variant='contained' disabled={!isConnected}>Save</Button>
        <Button onClick={handleClear} variant='outlined'>Clear</Button>
      </Box>
    </Box>
    </>
  );
}
